import { getCurrentPath } from "@faire/web/common/Path";
import { isPrerender } from "@faire/web/common/user-agent/isPrerender";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { matchPathWithLocale } from "@faire/web/ui/routing/react-utils";
import { observer } from "mobx-react";
import React, { useCallback } from "react";
import styled from "styled-components";

import { TopSearch } from "@faire/retailer/components/TopSearch/TopSearch";
import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { home } from "@faire/retailer/paths";
import { useSettingNavSearchUX } from "@faire/retailer/settings/useSettingNavSearchUX";

import { topNavEvent } from "./Events";
import headerState from "./state";

interface IProps {
  className?: string;
  inputId: string;
  inputDataTestId: string;
  onFocus?: (element: HTMLDivElement | null, isOnToggle?: boolean) => void;
  onBlur?: () => void;
}

const HeaderSearch: React.FC<IProps> = ({
  onFocus,
  inputId,
  className,
  inputDataTestId,
  onBlur,
}) => {
  const { isMobile } = useViewport();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { isTreatment: isNavSearchUX } = useSettingNavSearchUX();

  // This function reference must be stable for page scrolling
  const headerSearchFocus = useCallback(
    (element: HTMLDivElement | null, isOnToggle?: boolean) => {
      topNavEvent("search");
      onFocus?.(element, isOnToggle);
    },
    [onFocus]
  );
  const isOnHome = matchPathWithLocale(getCurrentPath().pathname, home());
  const shouldAutofocus =
    (isMobile && !isLoggedInRetailer && !isNavSearchUX) ||
    (isPrerender() && isOnHome);

  return (
    <Container className={className}>
      <TopSearch
        inputId={inputId}
        inputDataTestId={inputDataTestId}
        autofocus={shouldAutofocus}
        onFocus={headerSearchFocus}
        onBlur={onBlur}
        searchQuery={headerState.searchQuery}
        searchVisible={headerState.searchVisible}
        setSearchQuery={headerState.setSearchQuery}
        showSearchQuery={headerState.showSearchQuery}
        hideSearchQuery={headerState.hideSearchQuery}
        clearSearchQuery={headerState.clearSearchQuery}
      />
    </Container>
  );
};

export default observer(HeaderSearch);

const Container = styled.div`
  flex: 1;
`;
